import dummyWaveformImg from '~/assets/dummy_waveform.jpg'
import TimelineCommonAsset from './TimelineCommonAsset'
import { secondsToTimelineTime } from '~/Util'

// TODO: all thumbnails should be provided by server? This dummy should be removed from repo

/**
 * @memberOf Assets
 * @extends {TimelineCommonAsset}
 */
class AudioAsset extends TimelineCommonAsset {

  constructor(data = {}) {
    const {
      thumbnail = dummyWaveformImg,
      ...rest
    } = data

    super({
      ...data,
      thumbnail,
    })

    // ---

    const {
      url = null,
      fadeInDuration = secondsToTimelineTime(3),
      fadeOutDuration = secondsToTimelineTime(3),
      categoryId = null,
      moodId = null,
      fadeInIsActive = false,
      fadeOutIsActive = false,
    } = rest

    this._url = url
    this._fadeInDuration = fadeInDuration
    this._fadeOutDuration = fadeOutDuration
    this._categoryId = categoryId
    this._moodId = moodId
    this._fadeInIsActive = fadeInIsActive
    this._fadeOutIsActive = fadeOutIsActive
  }

  // ---

  /**
   * @returns {string|null}
   */
  get url() {
    return this._url
  }

  // ---
  /**
   * @returns {number} 100-nanoseconds units
   */
  get fadeInDuration() {
    return this._fadeInDuration
  }

  /**
   * @param {number} duration
   */
  set fadeInDuration(duration) {
    this._fadeInDuration = duration
  }

  // ---

  /**
   * @returns {number} 100-nanoseconds units
   */
  get fadeOutDuration() {
    return this._fadeOutDuration
  }

  /**
   * @param {number} duration
   */
  set fadeOutDuration(duration) {
    this._fadeOutDuration = duration
  }

  /**
   * @returns {string}
   */
  get categoryId() {
    return this._categoryId
  }

  /**
   * @returns {string}
   */
  get moodId() {
    return this._moodId
  }

  // ---
  /**
   * @returns {boolean}
   */
  get fadeInIsActive() {
    return this._fadeInIsActive
  }

  /**
   * @param {boolean} isActive
   */
  set fadeInIsActive(isActive) {
    this._fadeInIsActive = isActive
  }


  // ---
  /**
   * @returns {boolean}
   */
  get fadeOutIsActive() {
    return this._fadeOutIsActive
  }

  /**
   * @param {boolean} isActive
   */
  set fadeOutIsActive(isActive) {
    this._fadeOutIsActive = isActive
  }

}

export default AudioAsset
